export default {
  strict: true,
  namespaced: true,
  state: {
    payoutForm: {
      show: false,
      form: {
        id: null,
        type: 'credit',
        transactionType: 'other',
        amount: 0,
        description: null,
        notes: null,
        reservationId: null,
        packageId: null
      },
      refresh: false
    },
    payoutNotes: {
      show: false,
      note: ''
    }
  },
  mutations: {
    setPayoutFormShow (state, value) { state.payoutForm.show = value },
    setPayoutFormNew (state) {
      state.payoutForm.form = {
        id: null,
        type: 'credit',
        transactionType: 'other',
        amount: 0,
        description: '',
        notes: '',
        reservationId: null,
        packageId: null
      }
    },
    setPayoutFormForm (state, value) { state.payoutForm.form = value },
    setPayoutFormId (state, value) { state.payoutForm.form.id = value},
    setPayoutFormType (state, value) { state.payoutForm.form.type = value},
    setPayoutFormTransactionType (state, value) { state.payoutForm.form.transactionType = value},
    setPayoutFormAmount (state, value) { state.payoutForm.form.amount = value},
    setPayoutFormDescription (state, value) { state.payoutForm.form.description = value},
    setPayoutFormNotes (state, value) { state.payoutForm.form.notes = value},
    setPayoutFormReservationId (state, value) { state.payoutForm.form.reservationId = value},
    setPayoutFormPackageId (state, value) { state.payoutForm.form.packageId = value},
    setPayoutFormRefresh (state, value) { state.payoutForm.refresh = value },
    setPayoutNotes (state, value) { state.payoutNotes = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/provider/payout-form.js